<div class="input-box-component">
  <label [htmlFor]="textBoxId"
         [innerText]="labelText | translate"
         [ngClass]="invalid && !_value ? 'error-color' : 'normal-color'">
  </label>
  <input [id]="textBoxId"
         [placeholder]="placeholder | translate"
         [type]="inputType"
         [min]="min"
         [max]="max"
         [name]="name"
         [(ngModel)]="_value"
         (change)="propagateText($event)"
         [ngClass]="invalid && !_value ? 'input-error' : 'input-normal '">
  <div class="invalid-feedback" *ngIf="invalid && !_value && errorText">
    <span [textContent]="errorText"></span>
  </div>
</div>
